import React, { Component, PropTypes } from 'react';
import ComponentTitle from '../shared/ComponentTitle';
import { TITLE_TYPE } from '../../constants/FRNBaseStyles';

let totalMountedNewsyVideoInstances = 0;

export default class NewsyVideo extends Component {
  static propTypes = {
    title: PropTypes.string,
    titleColor: PropTypes.string,
    newsyId: PropTypes.number.isRequired,
    titleType: PropTypes.string
  }

  constructor(props) {
    super(props);

    // We have only one NewsyVideo per page.
    this.widgetId = 'NewsyVideo';
  }

  componentDidMount() {
    if (!totalMountedNewsyVideoInstances) {
      const script = document.createElement("script");
      script.src = `https://videos-by.vemba.io/v2/placements/${this.props.newsyId}.js`;
      script.async = true;

      document.getElementById(this.widgetId).appendChild(script);
    }

    totalMountedNewsyVideoInstances++;
  }

  shouldComponentUpdate() {
    return false;
  }

  componentWillUnmount() {
    totalMountedNewsyVideoInstances--;
  }

  render() {
    const { titleColor, title, titleType = TITLE_TYPE.MODULE_TITLE } = this.props;

    //Only render a single instance at a time. If one is mounted, don't render another.
    if (totalMountedNewsyVideoInstances > 0) {
      console.warn('Cannot render more than one NewsyVideo component on the same page.');
      return null;
    }

    return (
      <div>
        {title ? <ComponentTitle titleType={titleType} title={title} color={titleColor} /> : null}
        <div id={this.widgetId} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/media/NewsyVideo.js